/* eslint-disable prettier/prettier */
// Saklar rilis fitur produk 303. Fiturnya sudah dirilis, jadi tampil di semua
// environment termasuk production. Sengaja tidak lagi digantungkan pada
// VUE_APP_ENVIRONMENT: berkas .env* tidak masuk Git dan pada mesin build production
// variabel itu tidak pernah diisi, sehingga fiturnya ikut mati di staging dan UAT
// tanpa gejala. Set `false` untuk menahannya kembali di semua environment, misalnya
// menjelang deploy yang tidak boleh ikut membawanya.
const isProductScopeEnabled = true

const constant = {
  apiUrl: process.env.VUE_APP_API_URL,
  passwordAuth: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%&?"_'-]{8,}$/,
  // Pembatasan pendaftaran peserta di akhir bulan.
  // `endpoint` relatif terhadap apiUrl — apiUrl sudah memuat prefix /api, jadi jangan
  // ditulis ulang di sini. `field` adalah key konfigurasi di Backend, dikirim sebagai
  // query `?key=`. `fallback` dipakai saat status gagal dibaca atau tidak dikenali,
  // supaya pembatasan tidak mati diam-diam karena response tak terduga.
  subscriptionRestriction: {
    endpoint: '/app/configuration',
    field: 'blocknewsubsendofmonth',
    fallback: true
  },
  // Produk yang punya menu tersendiri di sidenav. `code` dicocokkan dengan field
  // `code` produk dari Backend. Halaman Produk 303 hanya menampilkan peserta produk
  // ini dan halaman Peserta mengecualikannya, supaya satu peserta tidak muncul di
  // dua menu. `includeParam`/`excludeParam` adalah nama query param pada endpoint
  // /subscription; dipisah ke sini supaya penyesuaian kontrak Backend cukup di satu
  // tempat tanpa menyentuh komponen.
  // `paymentOrderParam` memfilter peserta berdasarkan pembayaran ke berapa; 0 berarti
  // semua. Endpoint-nya belum tersedia saat ini, jadi namanya ikut dikumpulkan di sini
  // bersama param produk supaya penyesuaian cukup di satu tempat.
  // `enabled` false mematikan seluruh pemisahan produk 303 sekaligus: menunya
  // disembunyikan dan halaman Peserta berhenti mengecualikan produk itu. Keduanya
  // harus mati bersamaan — kalau hanya menunya yang hilang, peserta produk 303 tidak
  // muncul di menu mana pun.
  productScope: {
    enabled: isProductScopeEnabled,
    code: '303',
    includeParam: 'productCode',
    excludeParam: 'excludeProductCode',
    paymentOrderParam: 'paymentOrder'
  },
  menus: [
    {
      title: 'Neraca',
      icon: 'mdi-scale-balance',
      route: '/accounting/balancesheet',
      slug: 'balancesheet',
      isActive: true,
      allow: ['administrator', 'manager', 'accounting']
    },
    {
      title: 'Laba Rugi',
      icon: 'mdi-chart-areaspline',
      route: '/accounting/profit-loss',
      slug: 'profit-loss',
      isActive: true,
      allow: ['administrator', 'manager', 'accounting']
    },
    {
      title: 'Buku Besar',
      icon: 'mdi-book-open',
      route: '/accounting/ledger',
      slug: 'ledger',
      isActive: true,
      allow: ['administrator', 'manager', 'accounting']
    },
    {
      title: 'Akun',
      icon: 'mdi-notebook',
      route: '/accounting/chartmain',
      slug: 'chartmain',
      isActive: true,
      allow: ['administrator', 'accounting']
    },
    {
      title: 'Jurnal',
      icon: 'mdi-notebook-edit-outline',
      route: '/accounting/journal',
      slug: 'journal',
      isActive: true,
      allow: ['administrator', 'accounting']
    },
    {
      title: 'Fee BMT',
      icon: 'mdi-cash-sync',
      route: '/accounting/sharing-fee',
      slug: 'sharing-fee',
      isActive: true,
      allow: ['administrator', 'accounting']
    },
    {
      title: 'Wilayah',
      icon: 'mdi-flag-outline',
      route: '/region',
      slug: 'region',
      isActive: true,
      allow: ['administrator', 'manager']
    },
    {
      title: 'BMT',
      icon: 'mdi-office-building-outline',
      route: '/company',
      slug: 'company',
      isActive: true,
      allow: ['administrator']
    },
    {
      title: 'Karyawan',
      icon: 'mdi-account-cog-outline',
      route: '/staff',
      slug: 'staff',
      isActive: true,
      allow: ['administrator']
    },
    {
      title: 'Produk',
      icon: 'mdi-file-document-multiple-outline',
      route: '/product',
      slug: 'product',
      isActive: true,
      allow: ['administrator', 'data input']
    },
    {
      title: 'Simulasi',
      icon: 'mdi-tooltip-question-outline',
      slug: 'subscription',
      route: '/subscription/simulation',
      isActive: true,
      allow: ['administrator', 'data input']
    },
    {
      title: 'Anggota',
      icon: 'mdi-account-multiple-plus-outline',
      route: '/member',
      slug: 'member',
      isActive: true,
      allow: ['administrator', 'data input', 'manager']
    },

    {
      // Nama resmi produknya, bukan kodenya. `code` di `productScope` tetap '303' karena itu
      // yang dicocokkan dengan Backend; yang di sini hanya label yang dibaca pengguna.
      title: 'Muawanah Kebajikan',
      icon: 'mdi-account-star-outline',
      slug: 'subscription',
      route: '/subscription/product-303',
      isActive: isProductScopeEnabled,
      allow: ['administrator', 'data input']
    },
    {
      title: 'Peserta',
      icon: 'mdi-account-cash-outline',
      slug: 'subscription',
      route: '/subscription/input',
      isActive: true,
      allow: ['administrator', 'data input']
    },
    {
      title: 'Pembayaran Iuran',
      icon: 'mdi-cash-check',
      slug: 'subscription',
      route: '/subscription/payment',
      isActive: true,
      allow: ['administrator', 'data input']
    },
    {
      title: 'Pengajuan Klaim',
      icon: 'mdi-account-heart-outline',
      slug: 'subscription',
      route: '/subscription/claim',
      isActive: true,
      allow: ['administrator']
    },
    {
      title: 'Riwayat Peserta',
      icon: 'mdi-account-convert',
      slug: 'subscription',
      route: '/subscription/history',
      isActive: true,
      allow: ['administrator', 'data input', 'manager']
    }
    // {
    //   title: 'Laporan',
    //   icon: 'mdi-chart-bell-curve-cumulative',
    //   slug: 'reporting',
    //   route: '/subscription/reporting',
    //   allow: ['administrator', 'data input', 'manager']
    // }
    // {
    //   title: 'Laporan',
    //   icon: 'mdi-chart-bell-curve',
    //   route: '/report',
    //   slug: 'report',
    //   allow: ['administrator', 'manager']
    // }
  ]
}

export default constant
